import { Box, Typography, Paper, TextField, Button, Divider } from '@mui/material';
import { Save as SaveIcon } from '@mui/icons-material';

export default function Settings() {
  return (
    <Box>
      <Typography variant="h4" component="h1" sx={{ mb: 3 }}>
        Настройки сайта
      </Typography>

      <Paper sx={{ p: 3 }}>
        <Typography variant="h6" gutterBottom>
          Основные настройки
        </Typography>
        
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, mt: 2 }}>
          <TextField
            label="Название сайта"
            defaultValue="Краснобла́г"
            fullWidth
          />
          <TextField
            label="Описание сайта"
            defaultValue="Официальный сайт Краснодарской епархии"
            fullWidth
            multiline
            rows={2}
          />
          <TextField
            label="Email для связи"
            defaultValue="info@krasnoblag.ru"
            fullWidth
          />
        </Box>

        <Divider sx={{ my: 3 }} />

        <Typography variant="h6" gutterBottom>
          SEO настройки
        </Typography>
        
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, mt: 2 }}>
          <TextField
            label="Meta заголовок"
            defaultValue="Краснобла́г - Краснодарская епархия"
            fullWidth
          />
          <TextField
            label="Meta описание"
            defaultValue="Официальный сайт Краснодарской епархии Русской Православной Церкви"
            fullWidth
            multiline
            rows={2}
          />
        </Box>

        <Box sx={{ mt: 3, display: 'flex', justifyContent: 'flex-end' }}>
          <Button
            variant="contained"
            startIcon={<SaveIcon />}
          >
            Сохранить настройки
          </Button>
        </Box>
      </Paper>
    </Box>
  );
}
